/* ==========================================================================
   FNDRY - First-order code, applied automatically (P12 2026-10-22)

   Once per visit, in the background, every visitor gets the first-order code
   (WELCOME10 by default, a setting on the cart drawer section). It uses
   Shopify's own shareable link, /discount/CODE, fetched without following its
   redirect: Shopify puts the code on the cart and sets the discount_code
   cookie for the visit, so checkout opens with it applied from every path -
   the drawer's button, /cart, Buy now and the express buttons. No redirect,
   no reload, nothing visible.

   - A visitor who already has a code keeps it: nothing happens when the
     discount_code cookie is set (her own link, an email link, or ours on an
     earlier page) or when the cart already carries any code.
   - Once per visit: sessionStorage remembers it, inside try/catch. Without
     storage the cookie check alone stops a second application.
   - "One use per customer" is Shopify's, enforced at checkout once she enters
     her email. Nothing here tries to tell a returning customer apart.
   - If the cart already had items, the drawer re-renders (fndry:cart:refresh)
     so its subtotal and the first-order line follow the cart.
   - It never stands in the way: any error leaves the store as it was.

   Loaded from sections/fndry-cart-drawer.liquid (on every page), only while
   the setting is on and the code is not empty.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__fndryAutoDiscount) return; /* editor re-injects can re-run this file */
  window.__fndryAutoDiscount = true;

  var KEY = 'fndry:auto-discount';

  var el = document.currentScript || document.querySelector('script[data-fndry-auto-discount]');
  var code = el ? String(el.getAttribute('data-code') || '').trim() : '';
  if (!code || typeof window.fetch !== 'function') return;
  if (window.Shopify && window.Shopify.designMode) return;

  function remembered() {
    try {
      return window.sessionStorage.getItem(KEY);
    } catch (e) {
      return null;
    }
  }

  function remember(value) {
    try {
      window.sessionStorage.setItem(KEY, value);
    } catch (e) {}
  }

  /* The code in the discount_code cookie, or '' when there is none. */
  function cookieCode() {
    var m = /(?:^|;\s*)discount_code=([^;]*)/.exec(document.cookie || '');
    if (!m) return '';
    try {
      return decodeURIComponent(m[1]).trim();
    } catch (e) {
      return m[1].trim();
    }
  }

  function rootUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return root || '/';
  }

  function drawerHasItems() {
    var c = document.querySelector('[data-fcd-content]');
    return !!c && (parseInt(c.getAttribute('data-item-count'), 10) || 0) > 0;
  }

  try {
    if (remembered()) return; /* done earlier in this visit */
    if (cookieCode()) {
      remember('kept'); /* she already has a code this visit: never overwrite it */
      return;
    }
  } catch (e) {
    return;
  }

  fetch(rootUrl() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
    .then(function (response) {
      if (!response.ok) throw new Error('cart ' + response.status);
      return response.json();
    })
    .then(function (cart) {
      var codes = (cart && cart.discount_codes) || [];
      if (codes.length || cookieCode()) {
        remember('kept'); /* a code is already on the cart: leave it */
        return;
      }
      return fetch(rootUrl() + 'discount/' + encodeURIComponent(code), {
        credentials: 'same-origin',
        redirect: 'manual'
      }).then(function () {
        if (!cookieCode()) return; /* not taken: try again on the next page */
        remember('applied');
        if ((cart && cart.item_count > 0) || drawerHasItems()) {
          document.dispatchEvent(new CustomEvent('fndry:cart:refresh'));
        }
      });
    })
    .catch(function () {});
})();
